import React, { useEffect, useState } from "react";
import { api } from "../api";
import { Box, Typography, TextField, Button, Stack, Snackbar, Alert } from "@mui/material";

export default function ContentEditor() {
  const [rows, setRows] = useState([]);
  const [toast, setToast] = useState(null);

  const load = () => api.get("/sk12_sitecontent").then((r) => setRows(r.data || []));
  useEffect(() => { load(); }, []);

  const save = async (row) => {
    await api.put(`/sk12_sitecontent/${row.apiid}`, {
      ContentKey: row.ContentKey,
      PageSlug: row.PageSlug || null,
      ContentType: row.ContentType || "text",
      ContentValue: row.ContentValue || "",
      UpdatedOn: new Date().toISOString(),
    });
    setToast("Saved");
  };

  const addKey = async () => {
    const apiid = crypto.randomUUID();
    await api.post("/sk12_sitecontent", {
      apiid, ContentKey: `new.key.${Date.now()}`, PageSlug: "home", ContentType: "text", ContentValue: "",
    });
    load();
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Typography variant="h5">Site Content</Typography>
        <Button variant="contained" onClick={addKey}>Add Content Key</Button>
      </Box>
      <Stack spacing={2}>
        {rows.map((row, i) => (
          <Box key={row.apiid} sx={{ border: "1px solid #eee", borderRadius: 2, p: 2 }}>
            <Typography variant="caption" color="text.secondary">
              {row.ContentKey}{row.PageSlug ? ` · ${row.PageSlug}` : ""}
            </Typography>
            <TextField fullWidth multiline minRows={2} value={row.ContentValue || ""} sx={{ mt: 1 }}
              onChange={(e) => setRows(rows.map((r, j) => (j === i ? { ...r, ContentValue: e.target.value } : r)))} />
            <Button size="small" sx={{ mt: 1 }} variant="outlined" onClick={() => save(rows[i])}>Save</Button>
          </Box>
        ))}
        {rows.length === 0 && <Typography color="text.secondary">No content entries yet.</Typography>}
      </Stack>
      <Snackbar open={!!toast} autoHideDuration={2000} onClose={() => setToast(null)}>
        <Alert severity="success">{toast}</Alert>
      </Snackbar>
    </Box>
  );
}
